import React from "react";
import { useNavigate } from "react-router-dom";

const ImpersonationBanner: React.FC = () => {
  const navigate = useNavigate();
  const impersonatorToken = localStorage.getItem("impersonator_token");
  const impersonatorUser = localStorage.getItem("impersonator_user");

  if (!impersonatorToken) {
    return null;
  }

  const handleExit = () => {
    if (impersonatorToken) {
      localStorage.setItem("auth_token", impersonatorToken);
    }
    if (impersonatorUser) {
      localStorage.setItem("user_data", impersonatorUser);
    }
    localStorage.removeItem("impersonator_token");
    localStorage.removeItem("impersonator_user");
    navigate("/admin/dashboard");
    window.location.reload();
  };

  return (
    <div className="bg-yellow-100 text-yellow-900 px-4 py-2 text-sm flex items-center justify-between">
      <span>
        You are impersonating a user. Actions are performed as that user.
      </span>
      <button
        onClick={handleExit}
        className="px-3 py-1 bg-yellow-300 rounded hover:bg-yellow-400"
      >
        Exit impersonation
      </button>
    </div>
  );
};

export default ImpersonationBanner;
